<ng-container *ngIf="teaser">
    <a *ngIf="!teaser.showHtmlContents && image" [href]="teaser.href" [attr.target]="teaser.target" (click)="trackBannerClicked()">
        <img disableOptimizedSrcset height="169" width="540" priority [ngSrc]="image" />
    </a>
    <div *ngIf="teaser.showHtmlContents && teaser.htmlContents" [innerHTML]="teaser.htmlContents | msTrust: 'html'"></div>
</ng-container>
